import React from "react";
import { GiHouse } from "react-icons/gi";
import { BsPersonPlusFill } from "react-icons/bs";
import { AiOutlineAim } from "react-icons/ai";

const WhyUs = ({language}) => {
  return (
    <>
      <div className="border border-gray-100 shadow-sm relative my-2 items-center flex flex-col pt-2 pb-8 bg-[#ecf8f3]">
        {language === 'en' && (
        <h1 className="font-bold text-4xl text-center py-16">Why Us</h1>
        )}
        {language === 'hi' && (
        <h1 className="font-bold text-4xl text-center py-16">हमें क्यों चुनें</h1>
        )}
        <div className="space-y-14 sm:space-x-14 flex flex-col sm:flex-row inline-block justify-center items-center text-center pb-4 lg:pb-0 md:pb-2 px-2">
          <div className="flex flex-col space-y-2 items-center align-top mt-14">
            <div className="rounded-full p-6 w-fit bg-orange-400 relative">
              {<AiOutlineAim className="absolute bottom-4 right-1 text-5xl" />}
            </div>
            {language === 'en' && (
            <p className="font-bold pt-4">Aim</p>
            )}
            {language === 'hi' && (
            <p className="font-bold pt-4">लक्ष्य</p>
            )}
            {language === 'en' && (
            <p>
              it's our aim to create spaces where people and activities thrive
              where customers get utmost satisfaction.
            </p>
            )}
            {language === 'hi' && (
            <p>
              हमारा उद्देश्य है कि हम ऐसे स्थानों को बनाएं जहां लोग और गतिविधियाँ फलने-फूलने का आनंद ले सकें, जहां ग्राहकों को अधिकतम संतोष मिले।
            </p>
            )}
          </div>
          <div className="flex flex-col space-y-2 items-center align-top">
            <div className="rounded-full p-6 w-fit bg-orange-400 relative">
              {
                <BsPersonPlusFill className="absolute bottom-4 right-1 text-5xl" />
              }
            </div>
            {language === 'en' && (
            <p className="font-bold pt-4">Team</p>
            )}
            {language === 'hi' && (
            <p className="font-bold pt-4">टीम</p>
            )}
            {language == 'en' && (
            <p>
              Our team is capable of handling all the projects from the initial
              concept in the actual completion throughout
            </p>
            )}
            {language == 'hi' && (
            <p>
              हमारी टीम प्रारंभिक अवधारणा से लेकर परियोजना के वास्तविक पूर्णता तक सभी परियोजनाओं का सम्पादन करने की क्षमता रखती है।
            </p>
            )}
          </div>
          <div className="flex flex-col space-y-2 items-center align-top">
            <div className="rounded-full p-6 w-fit bg-orange-400 relative">
              {<GiHouse className="absolute bottom-4 right-1 text-5xl" />}
            </div>
            {language === 'en' && (
            <p className="font-bold pt-3">Design</p>
            )}
            {language === 'hi' && (
            <p className="font-bold pt-3">डिज़ाइन</p>
            )}
            {language === 'en' && (
            <p>
              Our firm strives to create design that inspires, approaching each
              project, regardless of the size and scale
            </p>
            )}
            {language === 'hi' && (
            <p>
              हमारा दौरा उत्साहित करने वाली डिज़ाइन बनाने का प्रयास करता है, हर परियोजना को आकार और माप जैसा हो, उसे प्रगति प्रदर्शित करते हुए।
            </p>
            )}
          </div>
        </div>
      </div>
      {/* <div className="grid justify-items-stretch fixed bottom-8 right-2 mb-1 tr"> */}

      {/* </div> */}
    </>
  );
};

export default WhyUs;
